import { exportSharedExcel } from "@/business/sharedSample/application/exportSharedExcel";
import { getAllSharedSample } from "@/business/sharedSample/application/getAllSharedSample";
import { SharedSample } from "@/business/sharedSample/domain/sharedSample";
import { ref, Ref, onMounted, computed } from "vue";

export function sharedSamplesUse() {
  const sharedInfo: Ref<SharedSample[]> = ref([]);
  const query: Ref<string> = ref("");
  const route: Ref<string> = ref("");

  onMounted(async () => {
    sharedInfo.value = await getAllSharedSample.execute();
    route.value = await exportSharedExcel.execute();
  });

  const filterSharedInfo = computed(() => {
    let result = sharedInfo.value;

    if (query.value.length > 0) {
      result = filterQuery(result);
    }

    return result;
  });

  function filterQuery(actualSharedInfo: SharedSample[]): SharedSample[] {
    const normalizeQuery = query.value.toLowerCase();

    return actualSharedInfo.filter(
      (shared) =>
        (shared.idReference?.toLowerCase() ?? "").includes(normalizeQuery) ||
        (shared.emplid?.toLowerCase() ?? "").includes(normalizeQuery) ||
        (shared.name?.toLowerCase() ?? "").includes(normalizeQuery) ||
        (shared.clientCode?.toString().toLowerCase() ?? "").includes(
          normalizeQuery
        ) ||
        (shared.type?.toLowerCase() ?? "").includes(normalizeQuery)
    );
  }

  return {
    route,
    sharedInfo,
    query,
    filterSharedInfo,
  };
}
